export interface deleteModalI {
    nid:Number|null,
    show:Boolean
}
export const defaultDeleteModal = {
    nid:0,
    show:false,
}